export default __webpack_public_path__ + "static/media/img-welcome-bg@3x.8d04e783.jpg";